import { useState } from "react";

const Mobilenav = ({ items, activeItem, onSelect, className }) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div
      id="mobile-sidenav-dropdown"
      className={`mobile-sidenav-dropdown ${className}`}
    >
      <button
        className="mobile-sidenav-toggle"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{activeItem}</span>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          style={{
            transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            transition: "transform 0.2s",
          }}
        >
          <path
            d="M5 7.5L10 12.5L15 7.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="mobile-sidenav-menu">
          {items.map((item) => (
            <button
              key={item}
              onClick={() => {
                onSelect(item);
                setIsOpen(false);
              }}
              className={`mobile-sidenav-item ${
                activeItem === item ? "active" : ""
              }`}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default Mobilenav;
